import { render, staticRenderFns } from "./DatasetDetails.vue?vue&type=template&id=569b26ae&scoped=true"
import script from "./DatasetDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DatasetDetails.vue?vue&type=style&index=0&id=569b26ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569b26ae",
  null
  
)

export default component.exports